const translations = {
    cityErrorMessage: 'Invalid city',
    requiredErrorMessage: 'This field is required'
};

export default translations;
